import React, { useState } from 'react';
import useAxiosPrivate from '../../api/useAxiosPrivate';
import { notify } from '../toast';

const IncentivePanel = ({ role }) => {
    const axiosPrivate = useAxiosPrivate();
    const now = new Date();

    const [loading, setLoading] = useState(false);

    const [month, setMonth] = useState(now.getMonth() + 1);
    const [year, setYear] = useState(now.getFullYear());
    const [historical, setHistorical] = useState(null);
    const [registrations, setRegistrations] = useState([]);

    const fetchHistorical = async () => {
        try {
            setLoading(true);
            const res = await axiosPrivate.get(`/employee/getMonthlyIncentive?month=${month}&year=${year}`);
            setHistorical(res?.data);
            setRegistrations(res?.data?.registrationDetails);
            console.log(res?.data?.registrationDetails)
        } catch (err) {
            notify('failed', err?.response?.data?.message);
        } finally {
            setLoading(false);
        }
    };

    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const years = Array.from({ length: 5 }, (_, i) => now.getFullYear() - i);

    const fmt = (n) => `₹${Number(n || 0).toLocaleString('en-IN')}`;

    return (
        <>
            <div style={{ width: '70%', margin: '0 auto 30px' }}>
                <h3 style={{ color: 'var(--secondary-text-color)', marginBottom: 16 }}>Incentives</h3>

                <div style={{ ...styles.card, marginTop: 12 }}>
                    <h4 style={styles.cardTitle}>Monthly Lookup</h4>
                    <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center', marginBottom: 12 }}>
                        <select
                            className="formInput"
                            style={{ width: 'auto' }}
                            value={month}
                            onChange={e => setMonth(Number(e.target.value))}
                        >
                            {months.map((m, i) => (
                                <option key={i} value={i + 1}>{m}</option>
                            ))}
                        </select>
                        <select
                            className="formInput"
                            style={{ width: 'auto' }}
                            value={year}
                            onChange={e => setYear(Number(e.target.value))}
                        >
                            {years.map(y => (
                                <option key={y} value={y}>{y}</option>
                            ))}
                        </select>
                        <button className="add-btn" onClick={fetchHistorical} disabled={loading}>
                            {loading ? <span className="spinner" /> : 'Fetch'}
                        </button>
                    </div>

                    {historical && (
                        <div style={styles.row}>
                            {role !== 'village_cluster' ?
                                <>
                                    <Stat label="Direct Cards" value={historical.directRegistrations} />
                                    <Stat label="Direct Incentive" value={fmt(historical.directRegistrationIncentive)} />
                                </>
                                :
                                <>
                                    <Stat label="Cards" value={historical.directRegistrations} />
                                    <Stat label="Incentive" value={fmt(historical.directRegistrationIncentive)} />
                                </>
                            }

                            {role !== 'village_cluster' ?
                                <>
                                    <Stat label="Referral Cards" value={historical.referralRegistrations} />
                                    <Stat label="Referral Incentive" value={fmt(historical.referralIncentive)} />
                                </>
                                : <></>
                            }

                            <Stat label="Base Salary" value={fmt(historical.baseSalary)} />
                            <Stat label="Total Payout" value={fmt(historical.totalPayout)} highlight />
                        </div>
                    )}
                </div>
            </div>

            {// @ts-ignore
                registrations?.length !== 0 &&
                <section className="user-list">
                    <div className="list-header">
                        <span>Name</span>
                        <span>Registered on</span>
                        <span>Incentive</span>
                        <span>type</span>
                    </div>

                    <div className="list-body">
                        {// @ts-ignore
                            registrations.map((holder) => (
                                <div
                                    className="list-row"
                                    key={holder?.holderId}
                                >
                                    <span className='truncate' title={holder?.holderName} data-label="Name">{holder?.holderName}</span>
                                    <span className='truncate' title={holder?.date?.slice(0, 10)} data-label="Registered on">{holder?.date?.slice(0, 10)}</span>
                                    <span className='truncate' title={holder?.incentive} data-label="Incentive">{holder?.incentive}</span>
                                    <span className='truncate' title={holder?.type} data-label="type">{holder?.type}</span>
                                </div>
                            ))
                        }
                    </div>

                </section>
            }
        </>
    );
};

export const Stat = ({ label, value, highlight }) => (
    <div style={styles.stat}>
        <div style={styles.statLabel}>{label}</div>
        <div style={{ ...styles.statValue, color: highlight ? 'var(--secondary-text-color)' : 'inherit' }}>
            {value}
        </div>
    </div>
);

const styles = {
    card: {
        background: '#fff',
        border: '1px solid var(--text-accent-color)',
        borderRadius: 10,
        padding: '16px 20px',
    },
    cardTitle: {
        margin: '0 0 12px',
        color: 'var(--primary-text-color)',
        fontSize: '1rem',
    },
    row: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 16,
    },
    stat: {
        minWidth: 120,
        background: 'var(--secondary-color)',
        borderRadius: 8,
        padding: '10px 14px',
        flex: '1 1 120px',
    },
    statLabel: {
        fontSize: '0.75rem',
        color: '#666',
        marginBottom: 4,
    },
    statValue: {
        fontSize: '1.1rem',
        fontWeight: 'bold',
    },
};

export default IncentivePanel;
